var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingComponentPage',{attrs:{"title":"管理者の2要素認証","summary":"管理者権限の方に、認証アプリの6桁を必須にできます。"}},[_c('AdminMfaPolicySettings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }